module.exports = __webpack_public_path__ + "img/arrow-right.5149a408.svg";